import type {
  IFetchSurveyQuestionsPayload,
  ISubmitSurveyFeedbackPayload,
} from "@/model/survey";
import httpClient from "@/services/index";

export const fetchSurveyQuestions = async (
  fetchQuestionPayload: IFetchSurveyQuestionsPayload,
) => {
  const url = "/hra/surveyQueries";
  const { token, ...payload } = fetchQuestionPayload;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient.post(url, payload, config).then((res) => res.data);
};

export const submitSurveyFeedback = async (
  submitSurveyFeedbackPayload: ISubmitSurveyFeedbackPayload,
) => {
  const url = "/hra/saveSurveyFeedback";
  const { token, ...payload } = submitSurveyFeedbackPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient.post(url, payload, config).then((res) => res.data);
};
